export default __webpack_public_path__ + "static/media/2409.217477db.png";